// extracted by mini-css-extract-plugin
module.exports = {"dp3-bundle-dialog-form":"DialogForm_dp3-bundle-dialog-form__7tvwH"};